import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    fontSize: 18,
    flexDirection: 'column',
    paddingBottom: 20,
  },

  tableContainer:{
    width: '95%',
    overflowX: 'auto',
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',

  },

  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '95%',
    maxWidth: 'calc(95vw - 1rem)',
  },

  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '90vh',
    flexDirection: 'column',
  },

  loadingText: {
    marginTop: 20,
  },

  containers: {
    display: 'flex',
    flexDirection: 'row',
  },

  dataContainer: {
    margin: 20,
    padding: 15,
    backgroundColor: '#FFFFFF',
    width: 500,
    height: 300,
    boxShadow: '0px 0px 5px grey',
    borderRadius: 10,
  },

  modal: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    minHeight: 150,
    borderRadius: '10px',
    width: '80%',
    padding: '50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
  },

  noData: {
    width: '100%',
    height: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: Colors.loginLigthenPrimaryColor,
    '& > span:first-child':{
      fontSize: 130,
    },
    '& > span:last-child':{
      fontSize: 30,
    },
  },

  recapButtonDialog: {
    fontSize: '1.6rem',
    color: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.65rem',
    lineHeight: '150%',
    letterSpacing: '0.00938em',
  },
}))

export default styles
